import tw, { styled } from 'twin.macro';
import React from 'react';

import BlockContent from '@sanity/block-content-to-react';
import Markdown from 'react-markdown';

const LayoutMdx = styled.div`
  h1,
  h2 {
    ${tw`text-3xl font-bold mb-5`}
  }

  h3 {
    ${tw`text-2xl mt-5 mb-3 font-bold`}
  }
  h4 {
    ${tw`text-xl  mt-5 mb-3 font-semibold`}
  }

  a {
    ${tw`text-green font-bold underline cursor-pointer`}
  }

  img {
    ${tw`place-content-start flex	object-cover h-96 mx-auto my-5`}
  }

  strong {
    ${tw`font-bold`}
  }

  li,
  ul {
    ${tw`list-disc my-3`}
  }
  ol,
  ul {
    ${tw`pl-10 list-disc leading-5 text-black font-medium `}
  }
  p {
    ${tw`text-black font-medium mb-4`}
  }
`;

const PortableText = ({ content, body, children, ...props }) => {
  const serializers = {
    marks: {
      video: ({ mark }) => {
        if (!mark) return null;
        return (
          <div tw="aspect-w-16 aspect-h-9">
            <iframe
              title="vimeo-player"
              src="https://player.vimeo.com/video/51589652?h=836062ff9b"
              width="100%"
              height="100%"
              frameBorder="0"
              allowFullScreen
            />
          </div>
        );
      },
    },
  };

  return (
    <LayoutMdx>
      {body && (
        <BlockContent
          blocks={body}
          {...props}
          serializers={serializers}
          tw="mx-auto  px-10 py-8  md:px-20 max-w-screen-2xl"
        />
      )}
      {content && (
        <BlockContent
          blocks={content}
          serializers={serializers}
          tw="mx-auto  px-10 py-10  md:px-20 max-w-screen-2xl"
        />
      )}
      {children && <Markdown {...props}>{children}</Markdown>}
    </LayoutMdx>
  );
};

export default PortableText;
